const NUMERIC_VALUE_REGEX = /^-?\d+(\.\d+)?$/;

const parseRangeValue = (value) =>
    NUMERIC_VALUE_REGEX.test(value) ? Number(value) : value;

const readString = (rawValue) =>
    rawValue !== undefined && rawValue !== null && rawValue !== ""
        ? rawValue
        : undefined;

const readNumber = (rawValue) => {
    const parsed = parseInt(rawValue, 10);
    return parsed > 0 ? parsed : undefined;
};

const readBoolean = (rawValue) => {
    if (rawValue === "true") return true;
    if (rawValue === "false") return false;
    return undefined;
};

const readRange = (rawValue, subKeys) => {
    if (!rawValue) return undefined;
    const [first, second] = rawValue.split("_");
    if (
        first === undefined ||
        second === undefined ||
        first === "" ||
        second === ""
    )
        return undefined;
    return {
        [subKeys[0]]: parseRangeValue(first),
        [subKeys[1]]: parseRangeValue(second)
    };
};

export const buildQueryFromUrl = (routeQuery, schema) => {
    const query = {};
    (schema || []).forEach(({ key, subKeys = ["begin", "end"], type }) => {
        const rawValue = routeQuery ? routeQuery[key] : undefined;
        let value;
        switch (type) {
            case "string":
                value = readString(rawValue);
                break;
            case "number":
                value = readNumber(rawValue);
                break;
            case "boolean":
                value = readBoolean(rawValue);
                break;
            case "range":
                value = readRange(rawValue, subKeys);
                break;
        }
        if (value !== undefined) query[key] = value;
    });
    return query;
};

const writeString = (currentUrl, key, value) => {
    if (value !== undefined && value !== null && value !== "") {
        currentUrl.searchParams.set(key, value);
    } else {
        currentUrl.searchParams.delete(key);
    }
};

const writeNumber = (currentUrl, key, value) => {
    if (typeof value === "number" && value > 0) {
        currentUrl.searchParams.set(key, value);
    } else {
        currentUrl.searchParams.delete(key);
    }
};

const writeBoolean = (currentUrl, key, value) => {
    if (value !== undefined) {
        currentUrl.searchParams.set(key, value ? "true" : "false");
    } else {
        currentUrl.searchParams.delete(key);
    }
};

const writeRange = (currentUrl, key, value, subKeys) => {
    const first = value ? value[subKeys[0]] : undefined;
    const second = value ? value[subKeys[1]] : undefined;
    if (
        first !== undefined &&
        first !== null &&
        first !== "" &&
        second !== undefined &&
        second !== null &&
        second !== ""
    ) {
        currentUrl.searchParams.set(key, `${first}_${second}`);
    } else {
        currentUrl.searchParams.delete(key);
    }
};

export const pushFiltersToUrl = (query, schema) => {
    const currentUrl = new URL(window.location.href);
    (schema || []).forEach(({ key, subKeys = ["begin", "end"], type }) => {
        const value = query ? query[key] : undefined;
        switch (type) {
            case "string":
                writeString(currentUrl, key, value);
                break;
            case "number":
                writeNumber(currentUrl, key, value);
                break;
            case "boolean":
                writeBoolean(currentUrl, key, value);
                break;
            case "range":
                writeRange(currentUrl, key, value, subKeys);
                break;
        }
    });
    window.history.replaceState({}, "", currentUrl);
};
